import React, { Context, RefObject } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { PageItem } from '../components/component-switcher';
import { ReactComponent as Arrow } from '../assets/images/Arrow-Down.svg';

export interface CodeItem extends PageItem {
    description: string;
    code: string;
}

export interface CodeComponentProps {
    item: CodeItem;
}

export interface CodeComponentState {
    show: boolean;
}



class CodeComponent extends React.Component<any, CodeComponentState> {
    static contextType: Context<AppContextInterface | null> = AppContext;
    static context: AppContextInterface;
    state: CodeComponentState = {
        show: false,
    }
    public codeRef: RefObject<HTMLElement> = React.createRef();


    toggle() {
        this.setState((state) => ({ show: !state.show }))
    }
    copyToClipboard() {
        let listener = (e: any) => {

            e.clipboardData.setData("text/html", document.querySelector('.code-preview')?.innerHTML);
            e.clipboardData.setData("text/plain", document.querySelector('.code-preview')?.innerHTML);
            e.preventDefault();
        }

        /* let code = document.createElement('textarea');
         code.innerHTML = this.props.item.code;
         document.body.appendChild(code);
         code.select();*/
        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
        //document.body.removeChild(code);
        alert("Copied to clipboard")



    }

    render() {

        return (
            <div className="code-component">
                <p dangerouslySetInnerHTML={{ __html: this.props.description }} />

                <div className="flex-row">
                    <button onClick={this.copyToClipboard.bind(this)} className="clipboard-button link-button primary">Copy to Clipboard <Arrow className="arrow-down" /></button>
                </div>

                <div className="code-preview" onClick={this.copyToClipboard.bind(this)} dangerouslySetInnerHTML={{ __html: this.props.code }} />


            </div>
        );
    }
}

export default CodeComponent;
  /*
                <button onClick={this.toggle.bind(this)} className="clipboard-button link-button primary">{ this.state.show ? "Hide ":"Show " } Source </button>
            {this.state.show && <code ref={this.codeRef}>{this.props.item.code} </code> }

*/